export const getRecommendedTitle = (serviceProvider) => {
    if (!serviceProvider.recommended) return '';

    const parts = [
        'Recommended',
    ];
    if (serviceProvider.recommended.addedBy) {
        parts.push(`by ${serviceProvider.recommended.addedBy.email}`);
    }
    if (serviceProvider.recommended.endAt) {
        parts.push(`until ${new Date(serviceProvider.recommended.endAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`);
    }
    return parts.join(' ');
};



// WEBPACK FOOTER //
// ./app/helpers/ports.js